import _ from 'lodash'
import { useForm } from 'react-hook-form'

import api from '../../../services/api'
import useModal from '../../../hooks/useModal'
import Utils from '../../../utils'

import * as S from '../Modal.styles'
import { BasicNumberInputForForm } from '../../InputBoxes'
import { CompleteBtn } from '../../Buttons'

import { ReactComponent as CloseIcon } from '../../../assets/images/close_delete_icon.svg'

export default function UpdateWeeklyDelayModal(props) {
  const { control, handleSubmit } = useForm()
  const { closeModal, openModal } = useModal()

  async function updateWeeklyDelay(data) {
    const { sessionalPlanId, totalQuantityId, weeklyQuantityId, targetWeeklyQuantityId } = props
    api.patch(`/sessional-plans/${sessionalPlanId}/total-quantities/${totalQuantityId}/weekly-quantities/${weeklyQuantityId}/delays`
      , { targetWeeklyQuantityId, ...data })
      .then(result => {
        let _sessionalPlan = _.cloneDeep(props.sessionalPlan)
        const modifiedId = _.findIndex(_sessionalPlan.totalQuantityList, tq => tq.totalQuantityId === totalQuantityId)
        _sessionalPlan.totalQuantityList[modifiedId].weeklyQuantityList = result.data.weeklyQuantityList
        props.setSessionalPlan(_sessionalPlan)
        closeModal()
      })
      .catch(e => {
        console.error(e)
        openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
      })
  }

  return (
    <>
      <S.Background />
      <S.ModalBox height='250px' width='300px'>
        <CloseIcon
          className='close-icon'
          width='25px'
          onClick={closeModal}
        />
        <S.ModalContents width='80%' height='80%'>
          <S.Title>{props?.targetWeekNum} 주차로 딜레이</S.Title>
          <BasicNumberInputForForm
            control={control}
            defaultValue={props?.weeklyDelayedAmount || 0}
            label='딜레이 양'
            name='quantityToDelay'
            maxWidth='50%'
            rules={{
              required: '딜레이 양을 입력해 주세요',
              max: { value: props?.weeklyDelayedAmount, message: `${props?.weeklyDelayedAmount}보다 클 수 없습니다.` },
              validate: (v) => Utils.isZeroOrPosInt(v) || '0보다 크거나 같은 정수여야 합니다.'
          }}
            style={{ marginTop: '30px' }}
          />
          <S.BtnContainer>
            <CompleteBtn
              fontSize='1em'
              height='40px'
              width='100%'
              onClick={handleSubmit(updateWeeklyDelay)}
            >확인
            </CompleteBtn>
          </S.BtnContainer>
        </S.ModalContents>
      </S.ModalBox>
    </>
  )
}